// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subheading[data-v-2cf9f7e8]{padding:0;font-style:normal;font-weight:900;font-size:20px;line-height:26px;letter-spacing:.015em;color:#c6c8cd;margin:40px 0 0}@media(min-width:550px){.subheading[data-v-2cf9f7e8]{font-size:24px;line-height:29px;letter-spacing:unset}}", ""]);
// Exports
module.exports = exports;
